<template>
  <div>
    <search-list @findData="findData"></search-list>
  <div class="page-wrapper">
    <!--<a :href="baseUrl+'/invoice/downloadInvoiceList'" class="ivu-btn mb16 ivu-btn-primary" v-p="{api:'invoice/downloadInvoiceList'}">导出</a>-->
    <Button type="primary" class="mb16" @click.stop="download" v-p="{api:'invoice/downloadInvoiceList'}">导出</Button>
    <table-list
      title="" :columns="columns" :data="data" :loading="loading" :total="total" :current="current" @change-page="changePage"
    ></table-list>
  </div>
    <detail :n="detailN" :invoiceFid="invoiceFid"></detail>
  </div>
</template>
<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import {invoicelist,downloadInvoiceList} from "../../../api/invoice";
  import Detail from './components/Detail'
  import {modifyInvoiceStatus} from "../../../api/invoice";
  import {getBaseUrl} from "../../../utils/public";
  import {validateAndDownload} from "../../../utils/public";


  export default {
    name: "proinvoiceapply",
    components:{
      SearchList,
      TableList,
      Detail
      // Update
    },
    data(){
      return {
        baseUrl:'',
        detailN:0,
        invoiceFid:'',
        addN:0,
        loading:false,
        total:0,
        current:1,
        columns:[
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title:' '
          },
          {
            title: "发票抬头",
            key: "invoiceTitle",
            align: "center",
            width:160
          },
          {
            title:' '
          },
          {
            title: "费用项",
            key: "feeTypeTxt",
            align: "center",
            width:100,
          },
          {
            title:' '
          },
          {
            title: "金额",
            key: "invoiceAmount",
            align: "center",
             width:120,
          },
          {
            title:' '
          },
          {
            title: "开票周期",
            key: "circle",
            align: "center",
            width:200,
            render:(h,params)=>{
              return h('span',{},params.row['applyStartMonth']+'至'+params.row['applyEndMonth'])
            }
          },
          {
            title:' '
          },
          {
            title: "发票类别",
            key: "invoiceTypeTxt",
            align: "center",
            width:120,
          },
          {
            title:' '
          },
          {
            title: "发票状态",
            key: "opResultTxt",
            align: "center",
             width:100,
            render:(h,params)=>{
              if(params.row['opResult']===7){
                return h('span',{
                  style:{
                    color:'red'
                  },
                },params.row['opResultTxt'])
              }
              else {
                return h('span',{},params.row['opResultTxt'])
              }
            }
          },
          {
            title:' '
          },
          {
            title: "申请时间",
            key: "applyTime",
            align: "center",
             width:160,
          },
          {
            title:' '
          },
          {
            title: "房间号",
            key: "stockNumber",
            align: "center",
             width:120,
          },
          {
            title:' '
          },
          {
            title: "合同号",
            key: "contractCode",
            align: "center",
            width:180
          },
          {
            title:' '
          },
          {
            title: "主合同号",
            key: "parentContractCode",
            align: "center",
             width:160
          },
          {
            title:' '
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center",
            width:160
          },
          {
            title:' '
          },
          {
            title: "财务联系人",
            key: "financeContact",
            align: "center",
            width:100
          },
          {
            title:' '
          },
          {
            title: "联系电话",
            key: "financeContactPhone",
            align: "center",
            width:120,
            render:(h,params)=>{
              return h(
                "a",{
                  on:{
                    click:()=>{
                      params.row['isShow1']=true
                    }
                  }
                },  params.row['financeContactPhone']?(params.row['isShow1']?params.row['financeContactPhone']:'查看'):''
              )
            }
          },
          {
            title:' '
          },
          {
            title: "操作",
            width:150,
            key: "action",
            align: "center",
            fixed:'right',
            render:(h,params)=>{
              let invalidate=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'invoice/modifyInvoiceStatus'
                    }
                  }
                ],
                style:{
                  marginRight:'10px'
                },
                on:{
                  click:()=>{
                    this.modifyInvoiceStatus(params.row)
                  }
                }
              },'已出票')
              let detail=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'invoice/getInvoiceInfoByFid'
                    }
                  }
                ],
                style:{
                  marginRight:'10px'
                },
                on:{
                  click:()=>{
                    this.invoiceFid=params.row['fid']
                    this.detailN++
                  }
                }
              },'查看')
              let actions=[detail]
              if(params.row['opResult']===0 || params.row['opResult']===7){
                actions.push(invalidate)
              }
              return h('div',{},actions)
            }
          },
        ],
        data:[],
        searchData:{
          "applyEndTime": "",
          "applyStartTime": "",
          "contractCode": "",
          "feeType": "",
          "invoiceSource": 1,
          "invoiceTitle": "",
          "invoiceType": '',
          "limit": 10,
          "page": 1,
          "projectFid": "",
          "projectFids": "",
          "stockNumber": ""
        }
      }
    },
    methods:{
      download(){
        validateAndDownload(null,downloadInvoiceList,null)


      },

      getBaseUrl:getBaseUrl,
      modifyInvoiceStatus(item){
        this.$Modal.confirm({
          title:'已出票',
          content:'<p>确认此操作？</p>',
          onOk:()=>{
            let params={
              invoiceFid:item.fid,
              status:3,
            }
            modifyInvoiceStatus(params).then(res=>{
              this.$Message.success('操作成功')
              this.invoicelist()
            }).catch(error=>{})
          }
        })


      },
      invoicelist(){
        invoicelist(this.searchData).then(res=>{
          if(!res.data ||!res.data.rows){
            return
          }
          res.data.rows.forEach(ele=>{
            ele['isShow1']=false
          })
          this.data=res.data.rows
          this.total=res.data.total
        }).catch(error=>{})
      },

      findData(params){
        this.current=1
        this.searchData = Object.assign({}, params);
        this.invoicelist();
      },
      changePage(n){
        this.current=n
        this.searchData.page = n;
        this.invoicelist();
      }
    },
    created(){
      this.invoicelist()
      this.baseUrl=getBaseUrl()
    }
  }
</script>

<style scoped>

</style>
